import React from 'react';
import classes from 'classnames';
import styles from './PageTabs.module.scss';

interface Tab {
  id: string;
  label: string;
}

interface PageTabsProps {
  className?: string;
  tabs: Tab[];
  selectedTab?: string;
  tools?: any;
  onTabSelect?: (id: string) => void;
  viewTabs?: boolean;
}

const PageTabs: React.FC<PageTabsProps> = ({
  className,
  tabs,
  selectedTab,
  tools,
  onTabSelect,
  viewTabs = true,
}) => {
  return (
    <div
      className={classes(styles.pageTabs, {
        [className || '']: !!className,
      })}
    >
      <div
        className={styles.tabs}
        style={{
          visibility: viewTabs ? 'visible' : 'hidden',
        }}
      >
        {tabs.map((tab, index) => {
          return (
            <button
              key={`tab--${index}`}
              className={classes(styles.tab, {
                [styles.selectedTab]: selectedTab === tab.id,
              })}
              onClick={() => {
                onTabSelect?.(tab.id);
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
      {!!tools && <div className={styles.tools}>{tools}</div>}
    </div>
  );
};

export default PageTabs;
